/**
 * Created by wuyanbin on 2019/7/12
 */
import { CHECK_MONEY, CHECK_PERCENT } from '@/shared/reqexp';
import React, { Component } from 'react';
import { Form, Input } from 'antd';
import { connect } from '@souche-f2e/muji';
import { formatNumOrSpace } from '@/shared/functions';
const mapStateToProps = (rootState) => ({
    sellerPayRules: rootState.sellerPayRules,
});
class FixedRateComponent extends Component {
    constructor() {
        super(...arguments);
        this.onChange = (e, type) => {
            this.props.handleFixedRateChange({ type, value: formatNumOrSpace(e.target.value) });
        };
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { FixedRateNum, FixedRateMin, FixedRateMax, isEditAble, canInputZeroHundred } = this.props.fixedRate;
        return (<div style={{ marginTop: '-4px' }}>
        <div style={{ width: '300px' }}>
          <Form.Item>
            {getFieldDecorator('FixedRateNum', {
            initialValue: FixedRateNum,
            rules: [
                {
                    validator: CHECK_PERCENT(true, canInputZeroHundred),
                },
            ],
        })(<Input disabled={!isEditAble} addonAfter="%" placeholder="请输入比例" onChange={(e) => {
            this.onChange(e, 'FixedRateNum');
        }}/>)}
          </Form.Item>
        </div>
        <div style={{ display: 'flex', width: '300px' }}>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator('FixedRateMin', {
            initialValue: FixedRateMin,
            rules: [{ validator: CHECK_MONEY(false, 'hundred', 999999, true) }],
        })(<Input disabled={!isEditAble} placeholder="请输入下限" addonAfter="元" onChange={(e) => {
            this.onChange(e, 'FixedRateMin');
        }}/>)}
          </Form.Item>
          <div style={{ padding: '0px 5px', lineHeight: '40px' }}>-</div>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator('FixedRateMax', {
            initialValue: FixedRateMax,
            rules: [{ validator: CHECK_MONEY(false, 'hundred', 999999, true) }],
        })(<Input disabled={!isEditAble} placeholder="请输入上限" addonAfter="元" onChange={(e) => {
            this.onChange(e, 'FixedRateMax');
        }}/>)}
          </Form.Item>
        </div>
      </div>);
    }
}
export default connect(mapStateToProps)(FixedRateComponent);
